/**
 * Service, jota Packery-direktiivi käyttää itsensä rekisteröimiseen.
 *
 * Get-methodilla voi hakea sivulla olevan Packery-instanssin.
 */
app.factory("PackeryService",
	["$timeout", function($timeout) {

		var packeryList = {};

		/**
		 * Sisäiseen käyttöön Packery-direktiiville.
		 * @param name
		 * @param packery
		 * @param controls
		 * @constructor
		 */
		this.Register = function(name, packery, controls) {
			packeryList[name] = {
				packery: packery,
				controls: controls
			};
		};

		/**
		 * Hakee packery-instanssin.
		 * Palauttaa packeryn ja sen kontrollifunktiot.
		 *
		 * @param name
		 * @returns {{packery: Object, controls: Object}}
		 * @constructor
		 */
		this.Get = function(name) {
			return packeryList[name];
		};

		/**
		 * Sisäiseen käyttöön Packery-direktiiville.
		 * @param name
		 * @param packery
		 * @param controls
		 * @constructor
		 */
		this.Unregister = function(name) {
			if(packeryList.hasOwnProperty(name)) {
				delete packeryList[name];
			}
		};

		return this;
	}]
);